import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import WhatsAppFAB from './components/WhatsAppFAB';
import Home from './pages/Home';
import Buy from './pages/Buy';
import Sell from './pages/Sell';
import BrandPage from './pages/BrandPage';
import About from './pages/About';
import Contact from './pages/Contact';
import Admin from './pages/Admin';
import { seedSampleData } from './hooks/useFirestore';
import './styles/global.css';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function AppContent() {
  const location = useLocation();
  const isAdmin = location.pathname.startsWith('/admin');

  // Seed sample data on first visit
  useEffect(() => { seedSampleData(); }, []);

  return (
    <>
      <Navbar />
      <ScrollToTop />
      <main style={{ minHeight: 'calc(100vh - 64px)' }}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/buy" element={<Buy />} />
          <Route path="/sell" element={<Sell />} />
          <Route path="/surron-dubai" element={
            <BrandPage
              brand="Surron"
              title="Surron Dubai"
              description="Dubai's largest selection of Surron electric bikes. Light Bee, Storm Bee, Ultra Bee — new and used."
              seoTitle="Surron for Sale Dubai | Buy Surron Electric Bikes"
              seoDescription="Buy Surron Light Bee, Storm Bee, Ultra Bee in Dubai. New and used Surron e-bikes available."
            />
          } />
          <Route path="/talaria-dubai" element={
            <BrandPage
              brand="Talaria"
              title="Talaria Dubai"
              description="Talaria Sting MX3, MX4, and R series available in Dubai. Built for performance."
              seoTitle="Talaria for Sale Dubai | Buy Talaria Electric Bikes"
              seoDescription="Buy Talaria Sting MX3, MX4, R series in Dubai. Performance e-bikes for sale."
            />
          } />
          <Route path="/electric-scooters-dubai" element={
            <BrandPage
              brand="Kugoo"
              title="Electric Scooters Dubai"
              description="Kugoo, Segway, and more. Commuter scooters and high-performance electric scooters."
              seoTitle="Electric Scooters Dubai | Buy E-Scooters"
              seoDescription="Buy electric scooters in Dubai. Kugoo, Segway and more. Best prices, verified sellers."
            />
          } />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/admin/*" element={<Admin />} />

          {/* SEO Landing Pages */}
          <Route path="/used-ebikes-dubai" element={<Buy defaultFilter="used" />} />
          <Route path="/surron-for-sale-dubai" element={
            <BrandPage brand="Surron" title="Surron for Sale Dubai" description="Find new and used Surron electric bikes for sale in Dubai." />
          } />
          <Route path="/electric-dirt-bike-dubai" element={<Buy defaultFilter="dirt" />} />
          <Route path="/buy-electric-bike-dubai" element={<Buy />} />
          <Route path="/sell-electric-bike-dubai" element={<Sell />} />
        </Routes>
      </main>
      <Footer />
      {!isAdmin && <WhatsAppFAB />}
      <Toaster
        position="bottom-center"
        toastOptions={{
          style: { background: 'var(--dark-3)', color: 'var(--text)', border: '1px solid var(--dark-4)' },
          success: { iconTheme: { primary: 'var(--volt)', secondary: 'var(--dark)' } }
        }}
      />
    </>
  );
}

export default function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}
